import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { getWallets } from "./slice";

export const useWallets = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.wallets);
  const dispatch = useAppDispatch();

  const getWalletsHandler = useCallback(
    () => dispatch(getWallets({ userId })),
    [dispatch, userId]
  );

  return {
    state,
    getWallets: getWalletsHandler,
  };
};
